.tooltip {
  border-radius: var(--border-radius__sm);
  padding: var(--space__md) var(--space__md);
  outline: none;
  max-inline-size: 300px;
  display: flex;
  font-size: var(--font-size__sm);
  font-weight: var(--font-weight__regular);
  line-height: var(--line-height__2xs);
}

.light {
  background-color: var(--color__gray-100);
  color: var(--color__gray-800);
  border: 1px solid var(--color__gray-300);
}

.dark {
  color: var(--color__white);
  background-color: var(--color__gray-800);
  border: 2px solid var(--color__gray-800);
}

.tooltip:where([data-component='tooltip']) {
  /* fixes FF gap */
  transform: translate3d(0, 0, 0);
}

.tooltip[data-entering] {
  animation: show 200ms;
}

.tooltip[data-exiting] {
  animation: show 200ms reverse ease-in;
}

@keyframes show {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
